import React from "react";

export default function Yes() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 35C0 15.6765 15.6765 0 35 0C54.3235 0 70 15.6765 70 35C70 54.3235 54.3235 70 35 70C15.6765 70 0 54.3235 0 35ZM35 5.38462C18.6504 5.38462 5.38462 18.6504 5.38462 35C5.38462 51.3496 18.6504 64.6154 35 64.6154C51.3496 64.6154 64.6154 51.3496 64.6154 35C64.6154 18.6504 51.3496 5.38462 35 5.38462Z"
        fill="#0ACF83"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.885 19.4769C54.0236 20.4333 54.1712 22.1316 53.2149 23.2701L30.5995 50.1932C30.0983 50.7899 29.3631 51.1401 28.5839 51.1534C27.8048 51.1667 27.0581 50.8418 26.5368 50.2626L16.8445 39.4933C15.8498 38.3881 15.9394 36.6858 17.0446 35.6911C18.1498 34.6964 19.8521 34.786 20.8468 35.8912L28.4679 44.3591L49.0918 19.8068C50.0482 18.6682 51.7465 18.5206 52.885 19.4769Z"
        fill="#0ACF83"
      />
    </svg>
  );
}
